module.exports = __webpack_public_path__ + "static/media/salebyiocn.7d1fe48a.svg";